module.exports = __webpack_public_path__ + "static/media/Bird4.7c31904c.jpg";